module.exports = __webpack_public_path__ + "fonts/iconfont.fb1f3029.ttf";